Dropzone.autoDiscover = false;

jQuery(document).ready(function() {
  
  var 
    dropzones = [],
    faults = jQuery('#faults');
    invoice = jQuery('#invoice');
  ;
  
  jQuery('.dropzone').each(function(i, el){
    var name = jQuery(el).data('upload-key');
    var myDropzone = new Dropzone(el, {
      url: ajaxUrl,
      autoProcessQueue: false,
      uploadMultiple: false,
      parallelUploads: 10,
      maxFiles: 2,
      maxFilesize: 10,
      paramName: name,
      addRemoveLinks: true,
      acceptedFiles: ".pdf,.doc,.docx",
      init: function() {

        this.on('addedfile', function(file){
          var 
              attachmentsEl = jQuery(this.element).data('upload-element')
              attachments = jQuery(attachmentsEl),
              fileName = file.name.replace(/\s+/g, '_')
            ;
              attachments.val(attachments.val().length == 0 
                  ? attachments.val() + '' + fileName.trim()
                  : attachments.val() + ',' + fileName.trim()
            );
            jQuery('.file-upload-error').empty();
            jQuery('.dropzone-file-error').remove();
            
            if (this.files[2]!=null){
                this.removeFile(this.files[1]);
            }
        });
        this.on('removedfile', function(file) {
          var 
            attachmentsEl = jQuery(this.element).data('upload-element'),
            attachments = jQuery(attachmentsEl)
          ;
              var files = attachments.val().split(',');
                  index = files.indexOf(file.name);

            if (index > -1) {
                files.splice(index, 1);
            }
            attachments.val(files.join().trim());
            jQuery('.dropzone-file-error').remove();
            jQuery('.file-upload-error').find('p').remove();
        });
        this.on('error', function(file, errorMessage) {
          if (jQuery('.dropzone-file-error').length == 0) {
              jQuery(el).after('<p class="dropzone-file-error">' + errorMessage + '</p>');
            }
        });
      }
    });
    dropzones.push(myDropzone);
  });


  jQuery(document).on('handle-uploads', 'form', function(event, form){
    var 
        formData = new FormData(form),
        attachments = [],
        submitBtn = jQuery(form).find('[type="submit"]'),
        action = jQuery(form).data('file-upload-action')
    ;
    
    formData.append('action', action);
    submitBtn.prop('disabled', true).text('Submitting...');
    jQuery.each(dropzones, function(index, dropzone) {
      var 
            paramName = dropzone.options.paramName
        ;

      jQuery.each(dropzone.files, function(i, file) { 

        formData.append('file_attachments[' + paramName + ']['+ i +']', file);
      });
    });

    $.ajax({
        url: ajaxUrl,
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function(response) {
          var 
            formEl = jQuery(form),
            files
          ;

          formEl.find('.dropzone-file-error').remove();
          files = Object.values(response.data.file).join(",");
          formEl.find('[name="file-upload"]').val(files);

          if (response.data.success == false) {
            jQuery('.file-upload-error').empty().append('<p>' + response.data.error + '</p>');
            submitBtn.prop('disabled', false).text(submitBtn.data('init-value'));
          } else {
            formEl.trigger('form-success');
          }
        },
        error: function(response) {
          submitBtn.prop('disabled', false).text(submitBtn.data('init-value'));
      }
    });
  });
});